module.exports = __webpack_public_path__ + "static/media/picnic-basket.93803c74.png";